import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AssetTimelineItem, OrderStatus } from '@zero/shared/util-models';

@Component({
  selector: 'instrument-details-instrument-asset-timeline-item',
  templateUrl: './asset-timeline-item.component.html',
  styleUrls: ['./asset-timeline-item.component.scss'],
  imports: [DatePipe, DecimalPipe, TranslocoPipe],
})
export class AssetTimelineItemComponent {
  @Input() public item: AssetTimelineItem;

  public readonly orderStatus = OrderStatus;
}
